var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("static/hotel/date.png")

  var m1 = require("static/sound/rIcon.png")

  var g0 = parseFloat(_vm.t.grade).toFixed(1)

  var l0 = _vm.__map(_vm.list, function(t, __i0__) {
    var m2 = _vm.$getImg(t.cover)
    return {
      $orig: _vm.__get_orig(t),
      m2: m2
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        g0: g0,
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }